import styled, { css } from 'styled-components'

import { IS_MRLOFT } from 'Config/config'
import Flex from 'Components/Flex'
import SvgIcon from 'Components/SvgIcon'
import AppButton from 'Components/AppButton'

import {
  MAP_PANEL_FILTER_SEARCH_TEXT_COLOR, FILTER_SEARCH_INACTIVE_BG_COLOR, FONT_BASE_COLOR, TEXT_GREY, PRIMARY_DARK_COLOR,
  OUTLINE_COLOR, CLICKABLE_COLOR, MAP_PANEL_FILTER_SEARCH_BACKGROUND_COLOR, MAP_PANEL_FILTER_SEARCH_TEXT_COLOR_ACTIVE,
  GREY_BACKGROUND,
} from '@CSSVars/colors'

import { BREAK_POINT_LG, HEADER_MENU_BREAK_POINT, HEADER_HEIGHT } from '@CSSVars/variables'

const PADDING = '16px'

export const _FilterSearch = styled.form.attrs(({ isFilterSearchOpen }) => ({
  className: isFilterSearchOpen ? ' open ' : ' close ',
}))`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: calc(100% - 100px);
  height: auto;
  max-width: 400px;
  position: relative;
  min-height: 40px;
  // background-color: ${MAP_PANEL_FILTER_SEARCH_BACKGROUND_COLOR};
  cursor: text;
  margin: 10px 0;
  z-index: 1000;
  border-radius: 10px;
  svg {
    fill: ${MAP_PANEL_FILTER_SEARCH_TEXT_COLOR};
  }

  input {
    display: inline-flex;
    vertical-align: middle;
    flex-grow: 1;
    width: 100%;
    height: 22px;
    padding: 0 ${PADDING};
    line-height: normal;
    color: ${(isFilterSearchOpen) => (isFilterSearchOpen ?
    MAP_PANEL_FILTER_SEARCH_TEXT_COLOR_ACTIVE : MAP_PANEL_FILTER_SEARCH_TEXT_COLOR)};
    border-radius: 0;
    background-color: transparent;
    border: none;
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    top: 120px;
    left: 0;
  }

  .react-autosuggest__container {
    background-color: transparent;
    margin-left: -16px;
  }

  .react-autosuggest__suggestions-container--open {
    max-height: 400px;
    width: calc(100% + 16px);
    overflow-y: auto;
    position: absolute;
    left: -16px;
    padding-top: 30px;
    top: 30px;
    //box-shadow: 1px 12px 29px -9px rgba(128,128,128,1);
    z-index: 10000;
  }
  @media screen and (min-width: ${HEADER_MENU_BREAK_POINT}) {
    .react-autosuggest__suggestions-container--open {
      width: 400px;
      left: -42.5px;
    }
  }


  @media screen and (max-width: ${HEADER_MENU_BREAK_POINT}) {
    .react-autosuggest__suggestions-container--open {
      width: calc(100% + 102px);
      left: -40px;
    }
  }

  @media screen and (max-width: ${BREAK_POINT_LG}) {
    padding-left: 0;
    min-width: 215px;
    svg {
      margin-left: 0;
    }
    ${({ isFilterSearchOpen, winHeight, isMobileApp }) => (isFilterSearchOpen ? `

      width: 100%;
      max-width: 100%;
      height: ${winHeight}px;
      padding: 12px 0;
      margin: 0;
      position: fixed;
      left: 0;
      top: ${isMobileApp ? '0' : HEADER_HEIGHT};
      align-items: flex-start;
      .react-autosuggest__suggestions-container--open {
        max-height: 400px;
        width: calc(100% + 102px);
        padding-bottom: 300px;
        box-shadow: none;
        position: absolute;
        overflow-y: auto;
        overscroll-behavior-y: auto;
        left: -40px !important;
        border-radius: 10px;
      }
    ` : `
      overflow: hidden;
    `)}
     ${({ fromNav }) => (fromNav ? `
    .react-autosuggest__suggestions-container--open {
      width: calc(100% + 102px);
      max-width: calc(100% + 102px);
      left: -40px;
    }` : ''
  )}
  }
  @media screen and (max-width: 320px) {
    min-width: initial;
  }
`

export const _FilterSearchInnerBox = styled(Flex).attrs({
  className: 'filterSearchInnerBox',
})`
  width: 100%;
  padding: 0 ${PADDING};
  overflow-x: ${({ isFilterSearchOpen }) => (!isFilterSearchOpen ? 'hidden' : '')};
  background-color: ${({ isFilterSearchOpen }) => (isFilterSearchOpen ? 'white' : FILTER_SEARCH_INACTIVE_BG_COLOR)};
  box-shadow: ${({ isFilterSearchOpen }) => (isFilterSearchOpen ? '1px 12px 29px -9px rgba(128,128,128,1)' : 'none')};
  position: absolute;
  top: 0;
  align-items: center;
  justify-content: center;
  > div {
    width: 100%;
  }
  height: auto;
  border-radius: 10px;
  @media screen and (min-width: ${BREAK_POINT_LG}) and (max-width: ${HEADER_MENU_BREAK_POINT}) {
    width: 500px;
    padding-right: 16px;
  }
  @media screen and (max-width: ${BREAK_POINT_LG}) {
    overflow-x: hidden;
    box-shadow: none;
    overflow-y: hidden;
    align-items: ${({ isFilterSearchOpen }) => (isFilterSearchOpen ? 'flex-start' : 'center')};
    height: ${({ isFilterSearchOpen, winHeight }) => (isFilterSearchOpen ? `${winHeight}px` : 'auto')};
  }
`
export const _LabelsContainer = styled.div`
  width: 100%;
  display: inline-flex;
  align-items: center;

  `

export const _SelectedAreaLabelContainer = styled.div`
  width: auto;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${({ isFilterSearchOpen }) =>
    (isFilterSearchOpen ? FONT_BASE_COLOR : 'white')};
  @media screen and (max-width: ${BREAK_POINT_LG}) {
    color: ${FONT_BASE_COLOR};
  }

  `

export const _MultipleAreaLabel = styled.span`
  position: relative;
  width: auto;
  white-space: nowrap;
  color: ${({ isFilterSearchOpen }) =>
    (isFilterSearchOpen ? FONT_BASE_COLOR : 'white')};
  &:before {
    content: ": ";
  }

  @media screen and (max-width: ${BREAK_POINT_LG}) {
    color: ${FONT_BASE_COLOR};
  }
`

export const _AreaLabel = styled.div`
  display: inline-flex;
  align-items: center;
  flex-wrap: nowrap;
  height: 40px;
  color: ${({ isFilterSearchOpen }) =>
    ((isFilterSearchOpen || IS_MRLOFT)
      ? FONT_BASE_COLOR
      : MAP_PANEL_FILTER_SEARCH_TEXT_COLOR)};
  background-color: ${({ isFilterSearchOpen }) => (isFilterSearchOpen ? 'white' : 'transparent')};
  cursor: default;
  margin-left: 0;
  // padding-left: 20px;
  // white-space: nowrap;
  margin-right: 3px;

  svg {
    fill: ${({ isFilterSearchOpen }) => (isFilterSearchOpen ? `
      black` : IS_MRLOFT ? FONT_BASE_COLOR : MAP_PANEL_FILTER_SEARCH_TEXT_COLOR)};
    margin: 0 8px 0 0
  }

  @media screen and (max-width: ${BREAK_POINT_LG}) {
    padding-left: 0;
    color: ${({ fromNav }) => ((fromNav && !IS_MRLOFT) ? 'white' : `${FONT_BASE_COLOR}`)};;

    ${({ isFilterSearchOpen }) => (isFilterSearchOpen ? `
      margin-bottom: 12px;
      width: 100%;
      margin-top: 12px;
    ` : '')}
  }
`

export const _ExcludeClearBtnWidth = styled.div`
  margin-right: 40px;
  width: calc(100% - 40px);
  height: ${({ fromNav }) => (fromNav ? `
    40px` : '54px'
  )};
  ${({ isFilterSearchOpen }) => (!isFilterSearchOpen ? `
    display: flex;
    align-items: center;
    ${_MultipleAreaLabel} {
      white-space: nowrap;
    }
  ` : `
    display: none;
  
  `)};

  ${({ showMobileFilterOpen }) => (showMobileFilterOpen && `
    height:0;
    min-height:0;
    ${_AreaLabel} {
      height:0;
    }
  `)};

`

export const _CommonAreaName = styled.div`
  padding: 4px 0 8px 0;
  color: ${TEXT_GREY};
`

export const _SearchContainer = styled.div`
  cursor: default !important;
  width: 100%;
  position: relative;
  background: white;
  padding-top: ${({ isFilterSearchOpen }) => (isFilterSearchOpen ? '12px' : '0')};

  ::-webkit-scrollbar-track {
    border: none;
    box-shadow: none;
    background-color: transparent;
  }
  ::-webkit-scrollbar {
    display: none;
  }
  ::-webkit-scrollbar-thumb {
    background: lightgrey;
    border-radius: 10px;
    cursor: pointer !important;
    &:hover {
      background: darkgrey;
    }
  }

  @media screen and (min-width: ${HEADER_MENU_BREAK_POINT}) {
    width: 100%;
    padding-top: 10px;
  }

  padding-bottom: ${({ extraPadding }) => (extraPadding ? '60px' : '10px')};
  overflow-y: scroll;
  max-height: ${({ isMobileApp }) => (!isMobileApp ? '70vh'
    : '80vh')};;
`

export const _MagnifyingGlassLeft = styled(SvgIcon)`
  position: absolute;
  right: 12px;
  transform: rotate(280deg);
  @media screen and (max-width: ${BREAK_POINT_LG}) {
    display: none;
  }
`

export const clearBtnCss = css`
  position: absolute;
  text-decoration: underline;
  color: ${CLICKABLE_COLOR};
  &:hover {
    cursor: pointer;
  }
`

export const _InputBox = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 108px;
  width: 100%;
  position: relative;
  border: 1px solid ${PRIMARY_DARK_COLOR};
  border-radius: 10px;
  margin-top: 10px;
`


export const _BottomRow = styled.div`
  height: 54px;
  padding: ${PADDING} 12px;
  border-top: 1px solid ${OUTLINE_COLOR};
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  input {
    margin-left: 12px;
    position: relative;
    margin-top: -18px;
    font-size: 14px;
    height: 16px;
  }

  input::placeholder {
    font-size: 12px;
  }
  position: relative;
`

export const _MiddleRow = styled.div`
  display: flex;
  min-height: 54px;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 12px 0;
  align-items: center;
  svg {
    margin: 0 10px;
  }
`

export const _MiddleRowClearBtn = styled.div`
  ${clearBtnCss};
  text-decoration: none;
  font-weight: 600;
  font-size: 12px;
  line-height: 22px;
  color: ${FONT_BASE_COLOR};
  right: 12px;
  margin-left: 10px;
`

export const _AreaSelected = styled.div`
  height: 26px;
  justify-content: center;
  background-color: ${GREY_BACKGROUND};
  width: 100%;
  display: flex;
  border-radius: 10px;
  border-top: 1px solid transparent;
`

export const _MagnifyingGlassIcon = styled(SvgIcon)`
  fill: ${PRIMARY_DARK_COLOR} !important;
  stroke: ${PRIMARY_DARK_COLOR};
  z-index: 200;
  transform: scale(-1,1);
  padding: 1px;
  height: 12px;
  width: 12px;
`

export const _DoneBtn = styled(AppButton)`

  right: 12px;
  width: 34px;
  span {
    font-size: 12px;
    line-height: 22px;
    font-weight: 600;
    color: ${PRIMARY_DARK_COLOR};
  }
  border: none;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  :disabled {
    span{
      color: ${TEXT_GREY};
    }
    background-color: white !important;
    border: none !important;
  }
`

export const _SelectedTagsDisplay = styled.div`
  margin: 0 12px;
  width: 85%;
`
